import React from 'react'
import Button from 'shared/ui/Button/Button'
import DatePickerInput from 'shared/components/DatePickerInput/DatePickerInput'
import { ReactComponent as FilterIcon } from 'assets/icons/filter.svg'
import ContentFiltersPanel from 'widgets/FiltersPanel/components/ContentFiltersPanel/ContentFiltersPanel'
import DropdownFilter from 'widgets/FiltersPanel/components/DropdownFilter/DropdownFilter'
import s from './LogsFiltersContent.module.scss'

export const LogsFiltersContent = ({
	draftFilters,
	studentOptions,
	notificationOptions,
	statusOptions,
	recipientOptions,
	onChangeKey,
	onChangeField,
	onApply,
	onClose,
}) => (
	<ContentFiltersPanel
		title="Filters"
		subtitle="Select multiple filters"
		icon={<FilterIcon />}
		onClose={onClose}
	>
		<div className={s.section}>
			<DropdownFilter
				filterKey="studentIds"
				title="Student"
				options={studentOptions}
				selected={draftFilters.studentIds || []}
				onChangeKey={onChangeKey}
			/>
			<DropdownFilter
				filterKey="notificationCodes"
				title="Notification"
				options={notificationOptions}
				selected={draftFilters.notificationCodes || []}
				onChangeKey={onChangeKey}
			/>
			<DropdownFilter
				filterKey="statuses"
				title="Status"
				options={statusOptions}
				selected={draftFilters.statuses || []}
				onChangeKey={onChangeKey}
			/>
			<DropdownFilter
				filterKey="recipientIds"
				title="Recipient"
				subtitle="Select recipient"
				options={recipientOptions}
				selected={draftFilters.recipientIds || []}
				onChangeKey={onChangeKey}
				searchable
				searchPlaceholder="Search by name or email"
			/>

			<div className={s.field}>
				<span className={s.field__label}>Date range</span>
				<div className={s.dates}>
					<div className={s.dateField}>
						<DatePickerInput
							className={s.dateInput}
							inputClassName={s.dateInputControl}
							value={draftFilters.dateFrom || ''}
							onChange={value => onChangeField('dateFrom', value || '')}
						/>
					</div>
					<div className={s.dateField}>
						<DatePickerInput
							className={s.dateInput}
							inputClassName={s.dateInputControl}
							value={draftFilters.dateTo || ''}
							onChange={value => onChangeField('dateTo', value || '')}
							minISO={draftFilters.dateFrom || undefined}
						/>
					</div>
				</div>
			</div>
		</div>

		<div className={s.actions}>
			<Button onClick={onApply}>Apply filters</Button>
		</div>
	</ContentFiltersPanel>
)

export default LogsFiltersContent
